export default [
    {
        name: 'cadastro-waba',
        path: 'waba',
        redirect: 'waba/index',
        component: () => import(/* webpackChunkName: 'cadastro-waba' */ '@/views/cadastro/waba/Index'),
        children: [
            {
                meta: {title: 'Números do WhatsApp'},
                name: 'cadastro-waba-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-waba' */ '@/views/cadastro/waba/List.vue'),
            },
            {
                meta: {title: 'Cadastro de número do WhatsApp'},
                name: 'cadastro-waba-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-waba' */ '@/views/cadastro/waba/Form.vue'),
            },
            {
                meta: {title: 'Edição de número do WhatsApp'},
                name: 'cadastro-waba-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-waba' */ '@/views/cadastro/waba/Form.vue'),
            },
        ],
    },
]
